import React from 'react';
import { Provider } from 'react-redux';
import withRedux from 'next-redux-wrapper';
import reduxStore from 'reduxStore';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import 'survey-react/survey.css';
import '../assets/scss/main.scss';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import theme from '../mui/theme';
import DefaultLayout from '../components/Global/Layout';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

const MyApp = ({
  Component, pageProps, router, store,
}) => {
  const noLayoutRoutes = ['/login', '/forgot-password', '/verify/[token]', '/resetpassword/[token]', '/_error', '/404'];
  const currentRoute = router.pathname;
  return (
    <Provider store={store}>
      <PersistGate persistor={store.__PERSISTOR} loading={null}>
        <ThemeProvider theme={theme}>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          {noLayoutRoutes.includes(currentRoute) ? (
            <Component {...pageProps} />
          ) : (
            <DefaultLayout>
              <Component {...pageProps} />
            </DefaultLayout>
          )}
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};
export default withRedux(reduxStore)(MyApp);
